// Kleine Bausteine des Gespraechs-Panels (VerhandlungsPassus.jsx): Sprech-
// blasen, die Zeile "was die Runde bewirkt hat", der Hinweis auf fehlende
// Absaetze bei "1 zu 1" und das Aufraeumen mit Rueckfrage.

import React, { useState } from 'react';
import { ArrowRight, Check, Sparkles, Trash2, X as XIcon } from 'lucide-react';
import { T, primaerKnopfStil } from '../../lib/designTokens';
import { aufraeumenFrage, fehlendAnfaenge, fehlendNummern } from '../../lib/gespraech';
import { textKnopfStil } from './abwaegenAnzeige';

export function Blase({ vonMir = false, rueckfrage = false, children }) {
  return (
    <div style={{
      alignSelf: vonMir ? 'flex-end' : 'flex-start',
      maxWidth: '86%',
      background: vonMir ? T.navy : (rueckfrage ? T.warnGrund : T.grund),
      color: vonMir ? T.flaeche : T.ink,
      border: `1px solid ${vonMir ? T.navy : (rueckfrage ? T.warnRand : T.randWeich)}`,
      borderRadius: T.rKarte, padding: '10px 12px',
      fontSize: T.tText, lineHeight: 1.6,
      whiteSpace: 'pre-wrap', wordBreak: 'break-word',
    }}>
      {rueckfrage ? (
        <div style={{ fontSize: T.tMikro, fontWeight: 700, color: T.warn, marginBottom: 4 }}>Rückfrage</div>
      ) : null}
      {children}
    </div>
  );
}

/** Unter der Antwort: was die Runde an den Listen getan hat, mit dem Weg dorthin. */
export function RundenErgebnis({ ergebnis, onZeigen }) {
  if (!ergebnis) return null;
  const { teile, ziel, nichtVerwendet, beruecksichtigt } = ergebnis;
  if (!teile.length && !nichtVerwendet.length && !beruecksichtigt) return null;
  return (
    <div style={{ alignSelf: 'flex-start', display: 'flex', flexDirection: 'column', gap: 4, paddingLeft: 2 }}>
      {/* Damit sichtbar ist, dass Freigaben und Ablehnungen aus den Reitern
          bei der KI angekommen sind (seit 29.09.2026). */}
      {beruecksichtigt ? (
        <div style={{ fontSize: T.tMikro, color: T.muted, lineHeight: 1.55 }}>{beruecksichtigt}</div>
      ) : null}
      {teile.length ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 7, flexWrap: 'wrap', fontSize: T.tMikro, color: T.body }}>
          <Check size={12} color={T.gut} />
          <span>{teile.join(' · ')}</span>
          <button type="button" onClick={() => onZeigen(ziel)} style={{ ...textKnopfStil, color: T.navy, marginLeft: 4 }}>
            Ansehen <ArrowRight size={11} />
          </button>
        </div>
      ) : null}
      {nichtVerwendet.length ? (
        <div style={{ fontSize: T.tMikro, color: T.muted, lineHeight: 1.55 }}>
          Nicht als Ergänzung übernommen: {nichtVerwendet.join(' · ')}
        </div>
      ) : null}
    </div>
  );
}

/** Bei "1 zu 1": nummerierte Absaetze, die in keinem Passus stehen. */
export function FehlendHinweis({ fehlend, kiBereit, onNachreichen, onSchliessen }) {
  return (
    <div role="alert" style={{
      padding: '10px 12px', borderRadius: T.rChip, background: T.warnGrund,
      borderLeft: `3px solid ${T.warn}`, display: 'flex', flexDirection: 'column', gap: 8,
    }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
        <div style={{ flex: 1, fontSize: T.tMeta, color: T.ink, lineHeight: 1.55 }}>
          <strong style={{ color: T.warn }}>Nicht vollständig übernommen:</strong>{' '}
          {fehlendNummern(fehlend)}
          <div style={{ color: T.muted, marginTop: 3, fontSize: T.tMikro }}>
            {fehlendAnfaenge(fehlend)}
          </div>
        </div>
        <button type="button" onClick={onSchliessen} aria-label="Hinweis schließen"
          style={{ border: 'none', background: 'transparent', color: T.muted, cursor: 'pointer', padding: 2 }}>
          <XIcon size={13} />
        </button>
      </div>
      <div>
        <button type="button" onClick={onNachreichen} disabled={!kiBereit}
          style={{ ...primaerKnopfStil, opacity: kiBereit ? 1 : 0.45 }}>
          <Sparkles size={12} /> Fehlende nachreichen
        </button>
      </div>
    </div>
  );
}

/** "Entwuerfe aufraeumen" mit Rueckfrage an Ort und Stelle - ohne KI. */
export function Aufraeumen({ anzahl, gesperrt, onEntfernen }) {
  const [fragen, setFragen] = useState(false);
  if (!anzahl) return null;
  if (!fragen) {
    return (
      <button type="button" onClick={() => setFragen(true)} disabled={gesperrt}
        title="Alle Entwürfe und Verworfenes entfernen — Freigegebenes und Zugestimmtes bleibt"
        style={{ ...textKnopfStil, opacity: gesperrt ? 0.45 : 1 }}>
        <Trash2 size={12} /> Entwürfe aufräumen
      </button>
    );
  }
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      <span style={{ fontSize: T.tMikro, color: T.body }}>
        {aufraeumenFrage(anzahl)}
      </span>
      <button type="button" disabled={gesperrt} onClick={() => { setFragen(false); onEntfernen(); }}
        style={{ ...textKnopfStil, color: T.gefahr }}>
        Entfernen
      </button>
      <button type="button" onClick={() => setFragen(false)} style={textKnopfStil}>Abbrechen</button>
    </span>
  );
}
